const checklist = {
	module: "Checklists",
	properties: "Properties",
	forms: "Forms",
	create_checklist: "Create Checklist",
	id: "ID",
};
export default checklist;